import { modalDescriptions as uk } from '../../i18n/ourServices/ua.js';
import { modalDescriptions as en } from '../../i18n/ourServices/en.js';
import { modalDescriptions as cs } from '../../i18n/ourServices/cz.js';
import { modalDescriptions as ru } from '../../i18n/ourServices/ru.js';
import { modalDescriptions as es } from '../../i18n/ourServices/es.js';
import { modalDescriptions as fr } from '../../i18n/ourServices/fr.js';
import { modalDescriptions as de } from '../../i18n/ourServices/de.js';
import { modalDescriptions as zh } from '../../i18n/ourServices/zh.js';

const lang = document.documentElement.lang || 'uk'; // або з localStorage

const descriptionsByLang = {
  uk,
  en,
  cs,
  ru,
  es,
  fr,
  de,
  zh,
};

export const modalDescriptions = descriptionsByLang[lang] || en;
